'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactPortal = require('react-portal');

var _reactPortal2 = _interopRequireDefault(_reactPortal);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The actual modal.
 */
var ActualModal = function (_React$Component) {
  (0, _inherits3.default)(ActualModal, _React$Component);

  function ActualModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActualModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActualModal.__proto__ || (0, _getPrototypeOf2.default)(ActualModal)).call.apply(_ref, [this].concat(args))), _this), _this.close = function () {
      if (_this.props.isControlled) {
        if (_this.props.onRequestClose) {
          _this.props.onRequestClose();
          return;
        }
      }

      _this.props.closePortal();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActualModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className;

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('Modal modal is-active', className) },
        _react2.default.createElement('div', { className: 'modal-background', onClick: this.close }),
        _react2.default.createElement(
          'div',
          { className: 'modal-container' },
          _react2.default.createElement(
            'div',
            { className: 'modal-content' },
            children
          )
        ),
        _react2.default.createElement('button', { className: 'modal-close', onClick: this.close })
      );
    }
  }]);
  return ActualModal;
}(_react2.default.Component);

ActualModal.propTypes = {
  isControlled: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onRequestClose: _propTypes2.default.func,
  closePortal: _propTypes2.default.func,
  children: _propTypes2.default.node
};

/**
 * A nice Modal component.
 *
 * Simple usage: <Modal openByClickOn={<button>lol</button>}>content</Modal>
 */

var Modal = function (_React$Component2) {
  (0, _inherits3.default)(Modal, _React$Component2);

  function Modal() {
    (0, _classCallCheck3.default)(this, Modal);
    return (0, _possibleConstructorReturn3.default)(this, (Modal.__proto__ || (0, _getPrototypeOf2.default)(Modal)).apply(this, arguments));
  }

  (0, _createClass3.default)(Modal, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          onRequestClose = _props2.onRequestClose,
          isOpened = _props2.isOpened,
          className = _props2.className,
          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'onRequestClose', 'isOpened', 'className']);

      return _react2.default.createElement(
        _reactPortal2.default,
        (0, _extends3.default)({}, isOpened !== undefined && { isOpened: isOpened }, other),
        _react2.default.createElement(
          ActualModal,
          { onRequestClose: onRequestClose, isControlled: isOpened !== undefined, className: className },
          children
        )
      );
    }
  }]);
  return Modal;
}(_react2.default.Component);

Modal.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  onRequestClose: _propTypes2.default.func,
  isOpened: _propTypes2.default.bool
};

exports.default = Modal;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/Modal/index.js
// module id = 153
// module chunks = 0